import React from "react";
import { Col } from "antd";
import { Link } from "react-router-dom";
import "./index.less";

export default ({
  section,
  type,
  image,
  image_title,
  image_alt,
  title,
  content,
  link,
}) => {
  let layout = null;
  if (type === "list-partners") {
    layout = (
      <li className={`listing__item__${type}`}>
        <div className={`listing__item__${type}__content`}>
          <div className="listing__imagem">
            <img
              src={`/images/${section}/${image}`}
              alt={image_alt}
              title={image_title}
            />
          </div>
          <div className="listing__text">
            <h1>
              {link ? (
                <a href={link} target="_blank">
                  {title}
                </a>
              ) : (
                title
              )}
            </h1>
            <span dangerouslySetInnerHTML={{ __html: content }}></span>
          </div>
        </div>
      </li>
    );
  } else if (
    type === "list_ist_coordenador" ||
    type === "list_ist_researchers" ||
    type === "norsus-coordinator-list"
  ) {
    layout = (
      <li className={`listing__item__${type}`}>
        <div className={`listing__item__${type}__content`}>
          <div className="listing__text">
            <div dangerouslySetInnerHTML={{ __html: content }}></div>
          </div>
        </div>
      </li>
    );
  } else if (
    type === "list_publications" ||
    type === "list_media" ||
    type === "list_events"
  ) {
    layout = (
      <li className={`listing__item__${type}`}>
        <div className={`listing__item__${type}__content`}>
          <div className="listing__imagem">
            <img
              src={`/images/${section}/${image}`}
              alt={image_alt}
              title={image_title}
            />
          </div>
          <div className="listing__text">
            <h1>
              {link ? (
                <a href={link} target="_blank">
                  {title}
                </a>
              ) : (
                title
              )}
            </h1>
            <span dangerouslySetInnerHTML={{ __html: content }}></span>
          </div>
        </div>
      </li>
    );
  } else if (type === "list_promoter") {
    layout = (
      <li className={`listing__item__${type}`}>
        <div className={`listing__item__${type}__content`}>
          <a href={link} target="_blank">
            <div className="listing__imagem">
              <img
                src={`/images/${section}/${image}`}
                alt={image_alt}
                title={image_title}
              />

            </div>
          </a>
        </div>
      </li>
    );
  } else {
    layout = (
      <li
        className="listing_item"
        style={{ backgroundImage: `url(/images/${section}/${image})` }}
      >
        <div className={`item__${type}`}>
          <h1>
            {link ? (
              <a href={link} target="_blank">
                {title}
              </a>
            ) : (
              title
            )}
          </h1>
          <div dangerouslySetInnerHTML={{ __html: content }}></div>
        </div>
      </li>
    );
  }
  return layout;
};
